import React from "react";
import { Link } from "react-router-dom";
import { topNavStyle } from "./nav/topNavStyle";
import BrandWordmark from "./BrandWordmark";

// Shared shell for the public legal and support pages. Matches the marketing
// nav used by Landing and HowToPlay so the pages do not read as a bolt-on.
// These pages must render without a session: the App Store review team and
// anyone who has not signed up will open them directly.

const link = { color: "var(--color-brand)", textDecoration: "none" };

export function P({ children }) {
  return (
    <p style={{ fontSize: 15, lineHeight: 1.65, color: "var(--color-text-muted)", margin: "0 0 16px" }}>
      {children}
    </p>
  );
}

export function Section({ title, children }) {
  return (
    <section style={{ marginBottom: 32 }}>
      <h2 style={{ fontSize: 18, fontWeight: 800, color: "var(--color-text-strong)", margin: "0 0 12px" }}>
        {title}
      </h2>
      {children}
    </section>
  );
}

export function List({ items }) {
  return (
    <ul style={{ margin: "0 0 16px", paddingLeft: 22 }}>
      {items.map((item, i) => (
        <li key={i} style={{ fontSize: 15, lineHeight: 1.65, color: "var(--color-text-muted)", marginBottom: 8 }}>
          {item}
        </li>
      ))}
    </ul>
  );
}

export function Mail({ address }) {
  return (
    <a href={`mailto:${address}`} style={link}>
      {address}
    </a>
  );
}

export default function LegalPage({ title, subtitle, children }) {
  return (
    <div
      className="theme-auto"
      style={{
        minHeight: "100vh",
        backgroundColor: "var(--color-bg-card)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <nav style={topNavStyle({ paddingX: 24, paddingY: 16 })}>
        <Link to="/">
          <BrandWordmark width="clamp(120px, 30vw, 200px)" />
        </Link>
        <Link to="/login" style={{ fontSize: 14, fontWeight: 600, ...link }}>
          Log in
        </Link>
      </nav>

      <main style={{ maxWidth: 680, margin: "0 auto", padding: "40px 24px 64px", flex: 1 }}>
        <h1 style={{ fontSize: 28, fontWeight: 900, color: "var(--color-text-strong)", margin: "0 0 8px" }}>
          {title}
        </h1>
        {subtitle && (
          <p style={{ fontSize: 14, color: "var(--color-text-muted)", margin: "0 0 40px" }}>{subtitle}</p>
        )}
        {children}
      </main>

      <footer
        style={{
          borderTop: "1px solid var(--color-bg-subtle)",
          padding: "24px",
          display: "flex",
          gap: 20,
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        <Link to="/privacy" style={{ fontSize: 13, ...link }}>
          Privacy
        </Link>
        <Link to="/terms" style={{ fontSize: 13, ...link }}>
          Terms
        </Link>
        <Link to="/support" style={{ fontSize: 13, ...link }}>
          Support
        </Link>
        <Link to="/delete-account" style={{ fontSize: 13, ...link }}>
          Delete Account
        </Link>
      </footer>
    </div>
  );
}
